import { AdapterInterface, Message } from '../../types/global';
import { ChatBotMessage, ChatBotResponse } from '../../api-models/types.gen';
import BaseAdapter from './baseAdapter';
import { HTTPMethod } from '../../types/enums';

export default class PostPolicyBot extends BaseAdapter<ChatBotResponse> implements AdapterInterface {
  rawResponse: ChatBotResponse;

  modifiedRequest: ChatBotMessage;

  async adaptResponse(request: Message[]): Promise<string> {
    const formattedRequest = this.adaptRequest(request);
    await this.fetchApiResponse('/api/policy-bot', HTTPMethod.Post, formattedRequest);
    return this.rawResponse.content;
  }

  adaptRequest(request: Message[]): ChatBotMessage {
    this.modifiedRequest = { content: request };
    return this.modifiedRequest;
  }
}
